import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { bigLogo } from "../../Assets";

const UnableToLoadData = () => {
  const { user_details } = useSelector((state) => state.authReducer);
  useEffect(() => {
    if (
      !(user_details && user_details !== null && user_details?.user?.merchant)
    ) {
      document.body.classList.add("white-bg");
    }
    return () => {
      document.body.classList.remove("white-bg");
    };
  }, [user_details]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="not-found-menu">
            <figure>
              <img src={bigLogo} />
            </figure>
            <h1>4 &nbsp; &nbsp;4</h1>
            <div className="error-details">No record found</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnableToLoadData;
